import { useEffect, useState } from "react";
//Material Ui
import { Box, FormControl, makeStyles, MenuItem, Select, TextField } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    input: {
        '& .MuiInputBase-input': {
            '&::-webkit-inner-spin-button': {
                webkitAppearance: 'none',
                mozAppearance: 'none',
                appearance: ' none',
                margin: 0
            },
        },
    },
    containerLimit: {
        margin: theme.spacing(1, 0, 0, 0),
        display: 'flex',
        gap: theme.spacing(2)
    },
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },

}));

export default function FilterEditShowBlockDIgram({ stateComponent, setStateComponent, resAutomateList }) {
    const classes = useStyles();
    const [objConfig, setObjConfig] = useState([
        {
            keyId: 'AUTOMATE_LIST',
            title: 'Seleccione un dispositivo Automate',
            options: [1, 2, 3, 4],
            disabled: false,
            selectedElement: null,
            selectedElementLlave: null
        },
        {
            keyId: 'BLOCK_DIAGRAM_LIST',
            title: 'Seleccione bloque del diagrama de su Automate',
            options: [1, 2, 3, 4],
            disabled: false,
            selectedElement: null
        },
        {
            keyId: 'TYPE_ELEMENT',
            title: stateComponent?.name === "Visualizador de bloques" ? 'Seleccione un tipo de visualizador' : 'Seleccione un tipo de controlador',
            options: stateComponent?.name === "Visualizador de bloques" ? [{ n: 'Gauge' }, { n: 'Led' }] : [{ n: 'Switch' }, { n: 'Pulsador' }],
            disabled: false,
            selectedElement: null
        }
    ])

    useEffect(() => {
        updateMultipleConfigs([
            {
                keyId: 'TYPE_ELEMENT',
                updates: {
                    title: stateComponent?.name === "Visualizador de bloques" ? 'Seleccione un tipo de visualizador' : 'Seleccione un tipo de controlador',
                    options: stateComponent?.name === "Visualizador de bloques" ? [{ n: 'Gauge' }, { n: 'Led' }] : [{ n: 'Switch' }, { n: 'Pulsador' }],
                    selectedElement: null
                },
            },
            {
                keyId: 'BLOCK_DIAGRAM_LIST',
                updates: {
                    disabled: true,
                    selectedElement: null
                },
            },
            {
                keyId: 'TYPE_ELEMENT',
                updates: {
                    disabled: false
                },
            },
        ]);
    }, [stateComponent.name])

    useEffect(() => {
        const loadData = async () => {
            // 1) Cargar automates SIEMPRE    
            const res = resAutomateList;
            if (res?.data) {
                updateMultipleConfigs([
                    {
                        keyId: "AUTOMATE_LIST",
                        updates: {
                            options: res.data,
                            disabled: true,
                        },
                    },
                ]);
            }
            // 2) Si existe indicator → procesarlo
            if (stateComponent?.indicator) {
                const parsed = parseToObject(stateComponent.indicator);
                const findAutomate = res?.data.find(
                    (e) => e.nombre === parsed[0].selectedElement
                );
                // Actualizar opciones de BLOCK_DIAGRAM_LIST Y AUTOMATE_LIST
                parsed[0].options = res?.data
                parsed[1].options = filterElementWithName(findAutomate?.diagram?.nodes);
                setObjConfig(parsed);
            }
        };
        loadData();
    }, []);

    useEffect(() => {
        setStateComponent(prevState => ({
            ...prevState,
            indicator: objConfig
        }))
    }, [objConfig])

    const parseToObject = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "object" && value !== null) {
            return Object.values(value);
        }
        if (typeof value === "string") {
            try {
                const trimmed = value.trim();
                const jsonString = trimmed
                    .replace(/'/g, '"')
                    .replace(/\bFalse\b/g, "false")
                    .replace(/\bTrue\b/g, "true")
                    .replace(/\bNone\b/g, "null");
                const parsed = JSON.parse(jsonString);
                if (Array.isArray(parsed)) return parsed;
                if (typeof parsed === "object" && parsed !== null) return Object.values(parsed);

                return objConfig;
            }
            catch (err) {
                console.error("Error parseando indicador:", err);
                return objConfig;
            }
        }
        return objConfig;
    };

    const updateMultipleConfigs = (updatesArray) => {
        setObjConfig(prev =>
            prev.map(item => {
                const found = updatesArray.find(u => u.keyId === item.keyId);
                return found ? { ...item, ...found.updates } : item;
            })
        );
    };

    const checkBlockType = (value) => {
        const validTypes = ['EVUP', 'EVUPA', 'EVUPD', 'VAUP', 'EVDO', 'EVDOA', 'EVDOD'];
        if (stateComponent?.name === "Visualizador de bloques") {
            return true;
        }
        else {
            return validTypes.includes(value);
        }
    }

    const filterElementWithName = opts => opts.filter(e => e?.n);

    const handleChangeSelectDevice = (elem) => {
        let name = elem.target.name
        let value = elem.target.value
        let type = value?.type
        if (name === 'AUTOMATE_LIST') {
            updateMultipleConfigs([
                {
                    keyId: 'AUTOMATE_LIST',
                    updates: {
                        selectedElement: value.nombre,
                        selectedElementLlave: value.llave
                    },
                },
                {
                    keyId: 'BLOCK_DIAGRAM_LIST',
                    updates: {
                        disabled: true,
                        options: filterElementWithName(value?.diagram?.nodes),
                        selectedElement: null
                    },
                },
                {
                    keyId: 'TYPE_ELEMENT',
                    updates: {
                        disabled: true,
                        selectedElement: null
                    },
                },
            ]);
        }
        if (name === 'BLOCK_DIAGRAM_LIST') {
            updateMultipleConfigs([
                {
                    keyId: 'BLOCK_DIAGRAM_LIST',
                    updates: {
                        selectedElement: value
                    },
                },
                {
                    keyId: 'TYPE_ELEMENT',
                    updates: {
                        disabled: checkBlockType(type)
                    },
                },
            ]);
        }
        if (name === 'TYPE_ELEMENT') {
            updateMultipleConfigs([
                {
                    keyId: 'TYPE_ELEMENT',
                    updates: {
                        selectedElement: value
                    },
                },
            ]);
        }
    }

    const readName = (value) => {
        if (value?.nombre) return value?.nombre
        if (value?.n) return value?.n
        if (value?.type) return value?.type
    }

    const handleLimitGauge = (elem) => {
        const { name, value } = elem.target
        updateMultipleConfigs([{
            keyId: 'TYPE_ELEMENT',
            updates: { [name]: value }
        }]);
    }

    // VERIFICA: SI NO ES ARRAY, NO RENDERIZA Y EVITA EL CRASH
    if (!Array.isArray(objConfig)) {
        return null;
    }

    return (
        <Box mt={1}>
        {
    objConfig?.map((element) => {

        // 👇 NUEVO: filtro condicional de options
        const filteredOptions =
            element.keyId === 'BLOCK_DIAGRAM_LIST'
                ? element?.options?.filter(opt => opt?.showInCustomDashboard === true)
                : element?.options;

        return (
            <Box mt={1} key={element.keyId}>
                {
                    element.disabled &&
                    <Box>
                        <Box className={classes.devicesLabel}>
                            {element.title}
                        </Box>

                        <FormControl fullWidth>
                            <Select
                                name={element.keyId}
                                value={element?.selectedElement || ""}
                                renderValue={(selected) =>
                                    typeof selected === "object"
                                        ? selected?.nombre || selected?.n || selected?.type || ""
                                        : selected || ""
                                }
                                onChange={handleChangeSelectDevice}
                            >
                                {filteredOptions?.map((elem, indx) => (
                                    <MenuItem key={indx} value={elem}>
                                        {readName(elem)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                }
            </Box>
        )
    })
}

            {
                objConfig[2]?.selectedElement?.n === 'Gauge' &&
                <Box mt={1} >
                    <Box className={classes.devicesLabel}>
                        Configure el límite máximo y mínimo
                    </Box>
                    <Box className={classes.containerLimit} >
                        <Box maxWidth='40%' >
                            <TextField
                                fullWidth
                                type='number'
                                name='min'
                                label='min'
                                size='small'
                                variant='outlined'
                                defaultValue='0'
                                value={objConfig[2]?.min}
                                onChange={handleLimitGauge}
                                className={classes.input}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                        <Box maxWidth='40%'>
                            <TextField
                                fullWidth
                                type='number'
                                name='max'
                                label='max'
                                size='small'
                                variant='outlined'
                                defaultValue='0'
                                value={objConfig[2]?.max}
                                onChange={handleLimitGauge}
                                className={classes.input}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                    </Box>
                </Box>
            }
        </Box>
    );
}
